import Card from "components/card"

export default function NoFactor() {
  return <Card title="Factor Not Found">
    <div className="content">
      <h4 className="p-3">The profile for this factor is currently unavailable.</h4>
    </div>
  </Card>
}
